<template>
  <div class="avatar-box ma-1">
    <div class="avatar-icon" data-cy="avatarIcon-avatar-image">
      <img
        :src="`https://assets.beeverso.org/avatar/${avatar.name}/${avatar.value}`"
        class="transition-all"
        id="main-avatar"
        alt="Avatar"
        :height="height ? height : 40"
        :width="width ? width : 40"
      />
    </div>
  </div>
</template>

<script>
import { DEFAULT_AVATAR } from "@/constants/DefaultConstants"

export default {
  props: {
    avatar: {
      type: Object,
      default: DEFAULT_AVATAR,
    },
    height: Number,
    width: Number
  },
  data() {
    return {
      timer: null,
    }
  },
  mounted() {
    const vm = this
    setTimeout(() => {
      vm.avatarUrl()
    }, 2000)
  },
  methods: {
    avatarUrl() {
      const avatarImg = document.querySelector('#main-avatar')
      if (avatarImg)
        avatarImg.setAttribute(
          'src',
          `https://assets.beeverso.org/avatar/${this.avatar.name}/${this.avatar.value}`
        )
    },
  },
}
</script>

<style lang="scss" scoped>

.avatar-box{
  background: #AEECB426;
}
.avatar-box img{
  border-radius: 100%;
}
.avatar-icon{
  position: relative;
}

</style>
